import React from 'react';

export const Slide = (props) => {
    const slideId = `slideId-${props.id}`;
    return (
        <li id={slideId} className="slide">
            {props.children}
        </li>
    );
};